import { SchemaFn } from '@angular/forms/signals';
import { metadataSchema } from '@shared/components/form/field/shared/form-field.function';

export interface ContactFilter {
    filter: string;
    name: string;
    email: string;
    city: string;
    types: string[];
}

export function createContactFilterModel(init?: Partial<ContactFilter>): ContactFilter {
    return {
        filter: init?.filter ?? '',
        name: init?.name ?? '',
        email: init?.email ?? '',
        city: init?.city ?? '',
        types: init?.types ?? [],
    };
}

export const contactFilterSchema: SchemaFn<ContactFilter> = (schema) => {
    metadataSchema(schema.filter, {
        displayName: 'Contact.List.Filter.Filter',
        placeholder: 'Contact.List.Filter.Filter',
    });
    metadataSchema(schema.name, {
        displayName: 'Contact.List.Filter.Name',
        placeholder: 'Contact.List.Filter.Name',
    });
    metadataSchema(schema.email, {
        displayName: 'Contact.List.Filter.Email',
        placeholder: 'Contact.List.Filter.Email',
    });
    metadataSchema(schema.city, {
        displayName: 'Contact.List.Filter.City',
        placeholder: 'Contact.List.Filter.City',
    });
    metadataSchema(schema.types, {
        displayName: 'Contact.List.Filter.Types',
        placeholder: 'Contact.List.Filter.Types',
    });
};
